import ComponentManager from "../../componentFramework";
import JsfJsCommand from "../JsfJsCommand/JsfJsCommand";
import EventListenerManager from "../EventListenerManager";
import OperatingSystemUtil from "../../scripts/OperatingSystemUtil";

/**
 * Adds following to search results:
 * 1) Selects the item on click
 * 2) Adds a context menu
 */
@ComponentManager.register()
export default class SearchResult {
	public static componentStyleClass = "searchResult";
	private readonly eventListenerManager = new EventListenerManager();
	private selectElem: HTMLElement | null = null;
	private isPossibleClickEvent = false;

	constructor(private readonly rootElement: HTMLElement) {
	}

	@ComponentManager.on("ready")
	protected componentReady() {
		this.selectElem = this.rootElement.classList.contains("searchResult__select")
			? this.rootElement : this.rootElement.querySelector(".searchResult__select");

		if (this.selectElem !== null) {
			const managedSelectElem = this.eventListenerManager.manage(this.selectElem);
			managedSelectElem.addEventListener("mousedown", () => {
				// Doing this because an ancestor element of this could cancel the mouse down. A simple click is still triggered if the mouse up is on this element even if the mouse down was stopped
				// Example: The inplace editing stops propagation but if you still select text in the input and mouse up on its parent SearchResult the "click" event is still triggered.
				this.isPossibleClickEvent = true;
			});

			const onMouseUp = (ev: MouseEvent) => {
				if (this.isPossibleClickEvent) {
					let isAddSelectionMode: boolean;
					if (this.selectElem !== null && this.selectElem.classList.contains("searchResult__select--mode_add")) {
						isAddSelectionMode = true;
					} else {
						isAddSelectionMode = OperatingSystemUtil.isMac() ? ev.metaKey : ev.ctrlKey;
					}
					const options = {
						params : {
							"keyModifier.shift": ev.shiftKey,
							"keyModifier.ctrl": isAddSelectionMode,
						}
					};
					JsfJsCommand.run("selectSearchResult", this.rootElement, options);
				}
				this.isPossibleClickEvent = false;
			};
			managedSelectElem.addEventListener("mouseup", onMouseUp);

			managedSelectElem.addEventListener("mouseout", () => {
				this.isPossibleClickEvent = false;
			});
		}
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.eventListenerManager.removeListeners();
	}
}
